export function validateEmail(email){
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export function validatePassword(password_one){
    const re = /(?=.*\d)(?=.*[a-zA-Z]).{8,}/;
    return re.test(password_one);
}

export function newValidatePassword(val) {
    return /^(?=.*[A-Za-z])(?=.*[0-9])[A-Za-z0-9!@#$%^&*_]\S{5,16}$/.test(val);
}

export function validateName(name) {
    // Expressão regular para aceitar letras (incluindo acentuadas) e espaços
    const re = /^[a-zA-ZÀ-ÖØ-öø-ÿ\s]+$/;
    return re.test(name);
}


export function checkEqual(text_one, text_two){
    return text_one === text_two;
}

export function validatePhone(phone){
    const re = /^[0-9]{8,13}/;
    return re.test(phone);
}

  

